import { useContext } from 'react';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import AdminDashboardComponent from '@/components/admin/AdminDashboard'; // Import the feature-rich component

const AdminDashboard = () => {
  const { user, logout } = useContext(AuthContext);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/30" data-testid="admin-dashboard-page">
      {/* Admin Specific Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div className="bg-indigo-600 text-white px-2 py-1 rounded text-xs font-bold uppercase tracking-wider">Admin Panel</div>
            <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              TukTuk Trading
            </h1>
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                <span className="text-purple-700 font-semibold text-sm">
                  {user?.name?.charAt(0).toUpperCase()}
                </span>
              </div>
              <span className="text-gray-700 font-medium">{user?.name}</span>
            </div>
            <Button onClick={logout} variant="outline" size="sm" data-testid="logout-btn">
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content - Only Admin Features */}
      <div className="container mx-auto px-6 py-8">
        <AdminDashboardComponent />
      </div>
    </div>
  );
};

export default AdminDashboard;
